/*@ngInject*/
const FormSummaryGridController = function ($rootScope, $scope, $state, $stateParams, $controller, $timeout, $window, xmlUtil, localization, modalUtil, formMediator, formViewerConstant, currencyFilter, formSummaryRepository, loadingBarHandler, coreConstant, currencyUtil, attachmentUtil, formSummaryGridUtil) {

    let translations,
        timeoutList = [];

    angular.extend(this, $controller('baseFormComponentController', {$scope: $scope}), $controller('baseDataSetFormComponentController', {$scope: $scope}));

    localization.getTranslations().then((result) => {
        translations = result;
        this.notEditableRowTooltip = _.get(translations, 'formsViewer.formSummary.notEditableRowTooltip');
    });

    this.isLoading = null;
    this.options = null;
    this.columnList = null;
    this.formSummaryList = [];
    this.gridHeight = null;
    this.gridWidth = null;
    this.isGridScrollingActive = false;
    this.sort = {
        columnName: 'rowIndexColumn',
        sortDirection: 'asc'
    };
    this.isDeleting = null;
    this.isWaitingForServerResponse = false;
    this.rowsToDelete = [];
    this.isFormSummaryHidden = false;
    this.isDeleteAllSelected = false;
    this.detailScreenOwnerUri = -1;
    this.acceptedTypes = ['.xls', '.xlsx'];
    this.enableAdd = false;
    this.enableDelete = false;

    this.$onInit = function () {
        let dataSetImmediateLoad = true,
            preventDataSetLoadIfConfigurableComponent = true;

        this.isLoading = true;

        this.options = xmlUtil.parseStringWithoutFlattening(this.fieldStructure.uiField.options).options;
        this.configureColumnList();

        this.onInitDataSetComponent(dataSetImmediateLoad, preventDataSetLoadIfConfigurableComponent).then(() => {
            this.configureDynamicDatasetItems(this.itemsList);

            if (!this.fieldStructure.isConfigurableComponent) {
                this.loadAddDeletePermissionConfig();
            }

            this.isLoading = false;
            this.addFormTooltip = _.get(translations, 'formsViewer.formSummary.addFormTooltip');
            this.trashIconTooltip = _.get(translations, 'formsViewer.formSummary.trashIconTooltip');
        });

        this.calculateGridHeight();
        this.formStructure = formMediator.getFormStructure(this.fieldStructure.rootFormId);
    };

    this.configureColumnList = function () {
        this.columnList = _.cloneDeep(this.options.formRepeaterSummary.summaryColumns.summaryColumn);

        // Because of the way the xmlUtil parses lists of tags, if the list of tags has only one, the
        // parser will set the attribute to an object, rather than an array of length one.
        if (!_.isArray(this.columnList)) {
            this.columnList = [this.columnList];
        }

        _.each(this.columnList, function (item, index, source) {
            source[index]._width = parseInt(item._width) + 20;
        });

        this.calculateGridWidth();
    };

    this.$onChanges = function () {
        this.isFormSummaryHidden = this.fieldStructure.dynamicProperties.hidden;
    };

    this.configureDynamicDatasetItems = function (itemsList) {
        this.formSummaryList = formSummaryGridUtil.processFormSummaryGridItems(itemsList);

        if (!_.isEmpty(this.formSummaryList)) {
            if (!_.isNil(this.formSummaryList[0])) {
                this.detailScreenOwnerUri = this.formSummaryList[0].value;
            }
        }
        this.sortFormSummary();
        this.calculateGridHeight();

        if ($scope.datagrid) {
            $scope.datagrid.update();
        }
    };

    this.calculateGridHeight = function () {
        let numberOfRows = this.formSummaryList.length || 1,
            maxRows = parseInt(this.options.maxRowsToDisplay),
            headerHeight = 70,
            rowHeight = 41,
            variableHeight = (numberOfRows * rowHeight) + headerHeight - 2,
            maxHeight = maxRows * rowHeight + headerHeight;

        this.gridHeight = numberOfRows > maxRows ? maxHeight : variableHeight;
        this.isGridScrollingActive = numberOfRows > maxRows;
    };

    this.calculateGridWidth = function () {
        let width = 0;

        _.each(this.columnList, function (item) {
            width += item._width;
        });

        this.gridWidth = width;
    };

    this.getColumnValue = function (formSummaryItemIndex, columnVariableName) {
        let formSummaryItem = this.formSummaryList[formSummaryItemIndex],
            currencyFormat,
            columnItem,
            result;

        _.each(this.formSummaryList, function (item) {
            if (item.name.index === formSummaryItemIndex) {
                formSummaryItem = item;
            }
        });

        formSummaryItem = formSummaryItem || {};
        columnItem = formSummaryItem.name[columnVariableName] || {};

        if (columnItem.validator === 'currency') {
            currencyFormat = currencyUtil.getCurrencyFormat(this.formStructure.currencyCode);
            result = currencyFilter(parseFloat(columnItem.value), currencyFormat.symbol, 0, currencyFormat.suffixSymbol, currencyFormat.customFormat);
        } else if (columnItem.validator === 'percent') {
            result = parseFloat(columnItem.value) + '%';
        } else {
            result = columnItem.value;
        }

        return result;
    };


    this.sortFormSummary = function () {
        let currentSortColumn = this.sort.columnName,
            currentSortDirection = this.sort.sortDirection,
            initialList = _.cloneDeep(this.formSummaryList),
            sortedList;

        if (_.isUndefined(initialList[0])) {
            return;
        }

        sortedList = _.sortBy(initialList, function (item) {
            let result;

            if (currentSortColumn === 'rowIndexColumn') {
                result = item.name.index;
            } else if (currentSortColumn === 'requiredFieldCount') {
                result = item.name.requiredCount.value;
            } else {
                result = item.name[currentSortColumn].value;
            }

            if (!isNaN(parseFloat(result)) && isFinite(result)) {
                result = parseFloat(result);
            }

            return result;
        });

        if (currentSortDirection === 'desc') {
            sortedList.reverse();
        }

        this.formSummaryList = sortedList;
    };

    this.isSorting = function (columnName, sortType) {
        return this.sort.columnName === columnName && this.sort.sortDirection === sortType;
    };

    this.onSort = function (columnName) {
        let currentSortDirection = this.sort.sortDirection;

        if (this.sort.columnName === columnName) {
            this.sort.sortDirection = currentSortDirection === 'asc' ? 'desc' : 'asc';
        } else {
            this.sort = {
                columnName: columnName,
                sortDirection: 'asc'
            };
        }

        this.sortFormSummary();
    };

    this.onInitializeDelete = function () {
        this.isDeleting = true;
        this.isDeleteAllSelected = false;
        this.updateSubmitDeleteButton();
        this.bulkUpdateHeight = 32;
    };

    this.onCancelDelete = function () {
        _.each(this.formSummaryList, function (item) {
            item.selected = false;
        });

        this.bulkUpdateHeight = 0;
        this.isDeleting = false;
        this.rowsToDelete = [];
    };

    this.onAddClick = function () {
        this.isWaitingForServerResponse = true;

        formMediator.addFormSummaryRow(this.fieldStructure.parentForm.id, this.fieldStructure.parentForm.submissionId, this.options.formRepeaterSummary.formTemplateName, this.options.addFormInstanceFunctionButtonExecutorName).then((result) => {
            $state.go('^.formSummaryGridDetail',
                {
                    formId: $stateParams.formId,
                    ownerUriId: this.detailScreenOwnerUri,
                    formSummaryInstanceId: result.id
                }
            );
            this.isWaitingForServerResponse = false;
        });
    };

    this.onImportClick = function (file, event) {
        let typeArray = [],
            inputType,
            submissionId,
            formTemplateName,
            allowFile = attachmentUtil.validateAttachmentType(file, _.get(translations, 'formsViewer.formSummary.unacceptableType'), this.acceptedTypes);

        if (allowFile) {
            typeArray = _.split(xmlUtil.parseString(this.fieldStructure.uiField.options).parameters, 'importType=');
            formTemplateName = xmlUtil.parseString(this.fieldStructure.uiField.options).formRepeaterSummary.formTemplateName;
            inputType = _.split(typeArray[1], '::')[0];
            submissionId = this.fieldStructure.parentForm.submissionId;
            loadingBarHandler.showLoadingBar(translations.formsViewer.formSummary.importLoadingBar);
            formMediator.importForms(submissionId, $stateParams.formId, inputType, formTemplateName, file).then(() => {
                let dataSetImmediateLoad = true,
                    preventDataSetLoadIfConfigurableComponent = false;

                loadingBarHandler.hideLoadingBar();

                this.onInitDataSetComponent(dataSetImmediateLoad, preventDataSetLoadIfConfigurableComponent).then(() => {
                    this.configureDynamicDatasetItems(this.itemsList);
                });
            });
        } else {
            event.target.value = null;
        }
    };

    this.onExportClick = function () {
        let exportFileName = xmlUtil.parseString(this.fieldStructure.uiField.options).formRepeaterSummary.formTemplateName;
        formSummaryRepository.getExportUrl(this.fieldStructure.parentForm.submissionId, $stateParams.formId, exportFileName).then((url) => {
            $window.open(url, '_blank');
        });
    };

    this.showImportButton = function () {
        return xmlUtil.parseString(this.fieldStructure.uiField.options).showImportButton;
    };

    this.showExportButton = function () {
        return xmlUtil.parseString(this.fieldStructure.uiField.options).showExportButton;
    };

    this.showExportOrImportButtons = function () {
        return xmlUtil.parseString(this.fieldStructure.uiField.options).showExportButton || (!this.fieldStructure.dynamicProperties.disabled && xmlUtil.parseString(this.fieldStructure.uiField.options).showImportButton);
    };

    this.onConfirmDelete = function () {
        let config = {
            cancelButtonLabel: translations.formsViewer.formSummary.cancel,
            confirmActionButtonLabel: translations.formsViewer.formSummary.confirm,
            summary: translations.formsViewer.formSummary.deleteConfirmationMessage,
            title: translations.formsViewer.formSummary.deleteConfirmationTitle
        };

        config.summary = config.summary.replace('{1}', this.rowsToDelete.length);
        config.summary = config.summary.replace('{2}', this.rowsToDelete.length > 1 ? 's' : '');

        modalUtil.showGenericConfirm(config).then(() => {
            let formIds = [];
            _.each(this.rowsToDelete, function (item) {
                formIds.push(item.value);
            });

            loadingBarHandler.showLoadingBar(translations.formsViewer.formSummary.deleteLoadingBar);
            formMediator.deleteFormSummaryRow(formIds).then(() => {
                this.onCancelDelete();
                loadingBarHandler.hideLoadingBar();
            });
        });
    };

    this.isFormSummaryItemDeleteEnabled = function (formSummaryItem) {
        let result = true;

        if (formSummaryItem.name.delete) {
            result = formSummaryItem.name.delete.enabled;
        }

        return result;
    };

    this.getRowTooltip = function (formSummaryItem) {
        if (!formSummaryItem.name.editable && !this.isDeleting) {
            return this.notEditableRowTooltip;
        }

        return null;
    };

    this.onRowClick = function (formSummaryItem) {
        if (!this.fieldStructure.parentForm.printPreview) {
            if (this.isDeleting) {
                if (this.isFormSummaryItemDeleteEnabled(formSummaryItem)) {
                    formSummaryItem.selected = !formSummaryItem.selected;

                    this.rowsToDelete = _.filter(this.formSummaryList, function (item) {
                        return item.selected === true;
                    });

                    this.updateSubmitDeleteButton();
                }
            } else {
                if (formSummaryItem.name.editable) {
                    $state.go('^.formSummaryGridDetail',
                        {
                            formId: $stateParams.formId,
                            ownerUriId: this.detailScreenOwnerUri,
                            formSummaryInstanceId: formSummaryItem.value
                        }
                    );
                }
            }

            this.isDeleteAllSelected = false;
        }
    };

    this.openFirstFormSummaryGridDetailWithRequiredFields = function () {
        _.each(this.formSummaryList, (formSummaryRow) => {
            if (formSummaryRow.name.requiredCount.value > 0) {
                this.onRowClick(formSummaryRow);
                return false;
            }
        });
    };

    this.updateSubmitDeleteButton = function () {
        let formSummaryListOptions = this.formSummaryList[0] ? this.formSummaryList[0].name : {},
            isRequired = !formSummaryListOptions.canDeleteAllRows;

        this.isSubmitDeleteEnabled = this.rowsToDelete.length !== 0;

        if (isRequired) {
            this.isSubmitDeleteEnabled = this.isSubmitDeleteEnabled && this.rowsToDelete.length !== this.formSummaryList.length;
        }
    };

    this.updateItems = function (updateEvent, data) {
        if (this.shouldUpdateItems(updateEvent, data)) {
            this.configureDynamicDatasetItems(data.items);
            this.loadAddDeletePermissionConfig();
        }
    };

    this.onDeleteAllClick = function () {
        _.each(this.formSummaryList, (item, index, source) => {
            if (this.isFormSummaryItemDeleteEnabled(item)) {
                source[index].selected = this.isDeleteAllSelected;
            }
        });

        this.rowsToDelete = _.filter(this.formSummaryList, function (item) {
            return item.selected === true;
        });

        this.updateSubmitDeleteButton();
    };

    this.$onDestroy = function () {
        _.each(timeoutList, function (item) {
            $timeout.cancel(item);
        });
    };

    this.loadAddDeletePermissionConfig = function () {
        let formId = this.fieldStructure.rootFormId,
            formSummaryGridFieldName = this.fieldStructure.uiField.fieldTemplate.variableName;

        formMediator.getFormSummaryAddDeleteConfigByFormSummaryGridFieldName(formId, formSummaryGridFieldName).then((result) => {
            this.enableAdd = result.enableAdd;
            this.enableDelete = result.enableDelete;
        });
    };

    this.updateFieldStructureOptions = function () {
        // Update the underlying XML
        this.fieldStructure.uiField.options = xmlUtil.toXmlString({options: this.options});
        $rootScope.$broadcast(formViewerConstant.event.formBuilder.FORM_TEMPLATE_UPDATED);
    };

    this.onEditableColumnLabelMouseOver = function () {
        $rootScope.$broadcast(formViewerConstant.event.formBuilder.DISABLE_DRAGGABLE_ELEMENTS);
    };

    this.onEditableColumnLabelMouseLeave = function () {
        $rootScope.$broadcast(formViewerConstant.event.formBuilder.ENABLE_DRAGGABLE_ELEMENTS);
    };

    this.onEditableColumnLabelBlur = function (event, column) {
        let dataChanged = false;

        // Because of the way the xmlUtil parses lists of tags, if the list of tags has only one, the
        // parser will set the attribute to an object, rather than an array of length one.
        if (!_.isArray(this.options.formRepeaterSummary.summaryColumns.summaryColumn)) {
            if (this.options.formRepeaterSummary.summaryColumns.summaryColumn._variableName === column._variableName) {
                if (this.options.formRepeaterSummary.summaryColumns.summaryColumn._columnHeading !== column._columnHeading) {
                    this.options.formRepeaterSummary.summaryColumns.summaryColumn._columnHeading = column._columnHeading;
                    dataChanged = true;
                }
            }
        } else {
            _.each(this.options.formRepeaterSummary.summaryColumns.summaryColumn, function (summaryColumn) {
                if (summaryColumn._variableName === column._variableName) {
                    if (summaryColumn._columnHeading !== column._columnHeading) {
                        summaryColumn._columnHeading = column._columnHeading;
                        dataChanged = true;
                    }
                    return false;
                }
            });
        }

        if (dataChanged) {
            this.updateFieldStructureOptions();
        }
    };

    $scope.$on(formViewerConstant.event.formBuilder.COLUMN_RESIZED, (event, columnIdentifier, newWidth) => {
        // Because of the way the xmlUtil parses lists of tags, if the list of tags has only one, the
        // parser will set the attribute to an object, rather than an array of length one.
        if (!_.isArray(this.options.formRepeaterSummary.summaryColumns.summaryColumn)) {
            if (this.options.formRepeaterSummary.summaryColumns.summaryColumn._variableName === columnIdentifier) {
                this.options.formRepeaterSummary.summaryColumns.summaryColumn._width = newWidth;
            }
        } else {
            _.each(this.options.formRepeaterSummary.summaryColumns.summaryColumn, function (summaryColumn) {
                if (summaryColumn._variableName === columnIdentifier) {
                    summaryColumn._width = newWidth;
                    return false;
                }
            });
        }

        this.updateFieldStructureOptions();
        this.configureColumnList();
    });

    $scope.$on(formViewerConstant.event.formBuilder.REARRANGE_COLUMN, (event, columnToRearrange, targetColumn, isLeftDrop) => {
        // Remove the column to rearrange from the list of columns:
        let summaryColumnToRearrange = _.remove(this.options.formRepeaterSummary.summaryColumns.summaryColumn, function (summaryColumn) {
                return summaryColumn._variableName === columnToRearrange;
            })[0],
            indexToInsertColumn = _.findIndex(this.options.formRepeaterSummary.summaryColumns.summaryColumn, function (summaryColumn) {
                return summaryColumn._variableName === targetColumn;
            });

        // Insert the column in the correct position:
        this.options.formRepeaterSummary.summaryColumns.summaryColumn.splice(isLeftDrop ? indexToInsertColumn : indexToInsertColumn + 1, 0, summaryColumnToRearrange);

        this.updateFieldStructureOptions();
        this.configureColumnList();
    });

    $scope.$on(formViewerConstant.event.SHOW_NEXT_REQUIRED_FIELD_FORM_SUMMARY_GRID, (event, fieldStructureId) => {
        if (this.fieldStructure.fieldStructureId === fieldStructureId) {
            this.openFirstFormSummaryGridDetailWithRequiredFields();
        }
    });

    $scope.$on(coreConstant.event.UPDATE_DATA_SET, this.updateItems.bind(this));

    $scope.$on(ux.datagrid.events.ON_STARTUP_COMPLETE, function (event, inst) {
        $scope.datagrid = inst;
        $scope.$apply();
    });
};

angular.module('umFormViewer')
    .controller('formSummaryGridController', FormSummaryGridController);
